module.exports = __webpack_public_path__ + "static/media/RH_Bay_only.2bd256c0.jpg";